import angular from 'angular';
import routes from './layout.routes';

import sidenavModule from './sidenav/sidenav.module';
import topHeaderModule from './top-header/top-header.module';
import headerModule from './header/header.module';
import footerModule from './footer/footer.module';

/**
 * @ngInject
 */
export default angular
  .module('app.layout', [
    sidenavModule,
    topHeaderModule,
    headerModule,
    footerModule
  ])
  .config(routes)
  .name;
